import { animateHUDValue } from './gsapAnimations.js';

export const WATCH_SAMPLES = {
  daytona: {
    name: 'Oris Aquis Date Calibre 400',
    verdict: 'Proceed',
    verdictKey: 'proceed',
    value: '$3,500',
    risk: 'Low · 4.8/5.0',
    pin1: 'SERIAL #72B3BE · VERIFIED CLEAN',
    pin2: 'BEZEL FONT: PERIOD CORRECT (2023)'
  },
  nautilus: {
    name: 'Patek Philippe Nautilus 5711/1A',
    verdict: 'Negotiate Below Floor',
    verdictKey: 'negotiate',
    value: '$68,500',
    risk: 'Moderate · 3.8/5.0',
    pin1: 'DIAL: AFTERMARKET REPOLISH DETECTED',
    pin2: 'SELLER: 3 DUPLICATE LISTINGS FOUND'
  },
  royaloak: {
    name: 'AP Royal Oak 15500ST',
    verdict: 'High Risk / Flagged',
    verdictKey: 'flagged',
    value: '$32,000',
    risk: 'High Risk · 2.1/5.0',
    pin1: 'SERIAL #92011 · STOLEN REGISTRY MATCH',
    pin2: 'CHAMFER: OVER-POLISHED LUG EDGE'
  }
};

export function initVerdictSimulator() {
  const sampleBtns = document.querySelectorAll('.sample-btn');

  sampleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const ref = btn.getAttribute('data-ref');
      if (!ref || !WATCH_SAMPLES[ref]) return;

      // Update active pill state
      sampleBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const data = WATCH_SAMPLES[ref];

      // Update HUD Values & Verdict Data Attribute
      const verdictEl = document.getElementById('hud-verdict');
      if (verdictEl) {
        verdictEl.setAttribute('data-verdict', data.verdictKey);
        animateHUDValue('hud-verdict', data.verdict);
      }

      animateHUDValue('hud-value', data.value);
      animateHUDValue('hud-risk', data.risk);

      // Update Scanner Pins
      const pin1El = document.querySelector('#scanner-pin .pin-label');
      const pin2El = document.querySelector('#scanner-pin-2 .pin-label');

      if (pin1El) pin1El.textContent = data.pin1;
      if (pin2El) pin2El.textContent = data.pin2;
    });
  });
}
